module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    class: {
      'show': _vm.showDropdown
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('b-input-group', [(_vm.searchRunning) ? _c('b-input-group-addon', {
    domProps: {
      "innerHTML": _vm._s(_vm.searchStatus)
    },
    slot: "right"
  }) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    on: {
      "input": _vm.update,
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.hit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.reset($event)
      }],
      "blur": function($event) {
        _vm.showDropdown = false
      },
      "focus": function($event) {
        _vm.showDropdown = _vm.items.length > 0
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "dropdown-item",
      class: {
        'active': _vm.isActive(index)
      },
      attrs: {
        "type": "button"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.title, _vm.value))
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.hit($event)
        },
        "mousemove": function($event) {
          _vm.setActive(index)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be4db33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Typeahead.vue
// module id = 481
// module chunks = 0